import styled from 'styled-components';
import { colorTextTertiary } from '@atlas-frontend/design-tokens';

export const TextSecondary = styled.span`
  color: ${colorTextTertiary};
`;
